import { render, staticRenderFns } from "./PersonalLoanStatusListing.vue?vue&type=template&id=36ab57d2"
import script from "./PersonalLoanStatusListing.vue?vue&type=script&lang=js"
export * from "./PersonalLoanStatusListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports